module.exports = __webpack_public_path__ + "static/media/gioweb2_logo.61873b9b.svg";